/** @format */

import React, {useContext} from 'react';
import {IconButton} from '@sttark/design-system';
import UploadFile from '../upload_file';
import {QuoteContext} from 'frontier-quoter';
import {useUploadHandler} from '../../../utilities/with_upload_handler';
import {useDesignHandler} from '@/ds/quoter/hoc/use_design_handler';
import {useDesignsOrdersHandler} from '@/ds/quoter/hoc/use_designs_orders_handler';
import {DESIGN_UPLOAD_MIMETYPES, REGEX_DESIGN_FILENAME} from 'frontier-constants';
import Dropzone from 'react-dropzone';

function GraphicDesignArtworkUploader(props) {
    const context = useContext(QuoteContext);
    let totalQtyPerDesign = Math.floor(context.order.total_qty / context.order.design_qty);
    if (isNaN(totalQtyPerDesign)) {
        totalQtyPerDesign = null;
    }

    const {
        designsOrders,
        handleUploadComplete,
        handleUploadCompleteAll,
        handleDeleteAllDesigns,
        handleDeleteDesign
    } = useDesignsOrdersHandler({
        orderId: context.order.id,
        lastUpdate: context.lastUpdate
    });

    const {
        dropping,
        uploading,
        fileProgress,
        handleDragEnter,
        handleDragLeave,
        handleDrop,
        handleClickAddFiles,
        handleCancelUpload,
        handleProcessFile
    } = useUploadHandler({
        orderId: context.order.id,
        saveFileEndpoint: '/account/designs/add/' + context.order.id + '/' + totalQtyPerDesign,
        pickOptions: {
            accept: {$set: DESIGN_UPLOAD_MIMETYPES},
            maxFiles: {$set: 200}
        },
        onUploadComplete: handleUploadComplete,
        onAllUploadsComplete: handleUploadCompleteAll
    });

    const hasDesigns = designsOrders.length > 0;

    return (
        <div>
            <Dropzone
                style={{position: 'static'}}
                noClick={true}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}>
                {({getRootProps}) => (
                    <div {...getRootProps()}>
                        <UploadFile
                            multiple
                            dropping={dropping}
                            numUploaded={designsOrders.length}
                            numUploading={Object.keys(fileProgress).length}
                            onClick={handleClickAddFiles}
                        />
                    </div>
                )}
            </Dropzone>
            {hasDesigns && (
                <>
                    <h5>Uploaded Designs</h5>
                    <div className="border-y">
                        {designsOrders.map(design => (
                            <Design
                                key={design.customer_filestack_id}
                                {...design}
                                onDelete={handleDeleteDesign.bind(
                                    this,
                                    design.id,
                                    design.customer_filestack_id
                                )}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

function Design(props) {
    const {
        isDeleting,
        isSwapping,
        designOrder,
        handleSwap,
        handleDelete,
        handleChangeQty,
        handleUpdateFilename
    } = useDesignHandler(props);

    return (
        <div className="hstack">
            <span className="ms-4 flex-grow-1">{props.customer_filename}</span>
            <span className="font-body-xl">
                <IconButton secondary icon="zoomin" onClick={() => window.open(props.signed_url)} />
                <IconButton secondary icon="trash" onClick={handleDelete} />
            </span>
        </div>
    );
}

export default GraphicDesignArtworkUploader;
